import React from "react";
import { Card } from "antd";
import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

export default function LevelChart() {
    const { t } = useTranslation();

    const option = {
        tooltip: {
            trigger: "axis",
            formatter: function (params) {
                let result = params[0].axisValue + "<br/>";
                params.forEach((item) => {
                    if (item.seriesName.includes(t('customer_report.spending'))) {
                        result += `${item.marker} ${item.seriesName}: ${item.value.toLocaleString()} VND<br/>`;
                    } else {
                        result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
                    }
                });
                return result;
            },
        },

        legend: {
            bottom: 0,
            data: [t('customer_report.customer_count'), t('customer_report.spending_vnd')],
        },

        grid: {
            left: 0,
            right: 10,
            top: 30,
            bottom: 50,
            containLabel: true,
        },

        xAxis: {
            type: "category",
            data: [t('customer_report.no_level'), t('customer_report.bronze'), t('customer_report.silver'), t('customer_report.gold'), t('customer_report.diamond'), t('customer_report.vip')],
        },

        yAxis: [
            { type: "value", name: t('customer_report.num_customers') },
            { type: "value", name: t('customer_report.spending') },
        ],

        series: [
            {
                name: t('customer_report.customer_count'),
                type: "bar",
                data: [120, 300, 500, 420, 260, 150],
            },
            {
                name: t('customer_report.spending_vnd'),
                type: "line",
                yAxisIndex: 1,
                smooth: true,
                data: [5000000, 12000000, 25000000, 40000000, 65000000, 90000000],
            },
        ],
    };

    return (
        <Card title={t('customer_report.level')}>
            <ReactECharts option={option} style={{ height: 260 }} />
        </Card>
    );
}